import * as React from "react";
import { toINR } from "../../../service/numberFormat";
import { jwtToken } from "../../../types/genericTypes";
import { parsedToken } from "../../../service/storageHelper";
import { IcommLimits } from "../../../types/components/fundTransfer/ftTypes";
import DeviceContext from "../../../service/indentifyDevice";
import { Idevice } from "../../../types/device";
const handleDevice: Idevice = DeviceContext();

export interface IFtPayInCashHeaderProps {
	eqCash: string;
	coCash: IcommLimits;
}

export function FtPayInCashHeader(props: IFtPayInCashHeaderProps) {
	const pToken: jwtToken | null = parsedToken();
	return (
		<div className={"ft_cash_header " + (pToken && pToken.accType === "COMEQ" ? "by2" : "")}>
			{pToken && pToken.accType === "COMEQ" && (
				<>
					<div className="cash_wrap eq_cash">
						<p className="cash_txt">Equity {!handleDevice.isMobile && "Cash"} </p>
						<p className="cash_val">
							<span className="rupy">&#x20b9;</span>
							{toINR(props.eqCash, 2)}
						</p>
					</div>
					<div className="cash_wrap com_wrap">
						<p className="cash_txt">Commodity {!handleDevice.isMobile && "Cash"}</p>
						<p className="cash_val">
							<span className="rupy">&#x20b9;</span>
							{toINR(props.coCash.lmAvl, 2)}
						</p>
					</div>
				</>
			)}
			{pToken && pToken.accType !== "COMEQ" && (
				<div className="cash_wrap">
					<p className="cash_txt">Cash Available</p>
					<p className="cash_val">
						<span className="rupy">&#x20b9;</span>
						{toINR(pToken.accType === "EQ" ? props.eqCash : props.coCash.lmAvl, 2)}
					</p>
				</div>
			)}
		</div>
	);
}
